import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { getLocalData } from "../utils/localStorage";
import { useNavigate } from "react-router-dom";

import Phone from "../components/Login/Phone";
import FacebookLogin from "../components/Login/FacebookLogin";
import GoogleLogin from "../components/Login/GoogleLogin";
import EmailLogin from "../components/Login/EmailLogin";

import Email from "../static/email.svg";
import CreateNewUser from "../components/Login/CreateNewUser";
import { Box } from "@mui/system";
function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    if (getLocalData("user-info")?.userToken?.length > 0) {
      navigate("/");
    }
  }, [getLocalData("user-info")?.userToken]);

  const [isLoginUsingPhoneNo, setIsLoginUsingPhoneNo] = useState(true);
  const [isLoginUsingEmail, setIsLoginUsingEmail] = useState(false);

  const [isRegistration, setIsRegistration] = useState(false);
  const [newEmail, setNewEmail] = useState("");

  return (
    <section className="space-at-top">
      <div className="container">
        {!isRegistration && (
          <Row className="pb-2">
            <Col md={12} className="d-flex justify-content-center">
              <Box  sx={{ width: { xs: '100%', lg: '35%', md: '70%' }}}>
                <div className="login-box">
                  {isLoginUsingPhoneNo && (
                    <div>
                      <span className="header-1-login">Login OR Sign Up</span>
                      <div>
                        <Phone />
                      </div>
                      <div className="login-or">
                        <span>OR</span>
                      </div>
                      <div className="login-btn-grp">
                        <GoogleLogin />
                        <FacebookLogin />
                        {/* <span
                          className="login-btn"
                          onClick={() => {
                            setIsLoginUsingEmail(true);
                            setIsLoginUsingPhoneNo(false);
                          }}
                        >
                          <img alt="email" src={Email} />
                        </span> */}
                      </div>
                    </div>
                  )}
                  {isLoginUsingEmail && (
                    <div>
                      <span className="header-1-login">
                        Login OR Sign Up Using Email
                      </span>
                      <div>
                        <EmailLogin
                          setIsRegistration={setIsRegistration}
                          setNewEmail={setNewEmail}
                        />
                      </div>
                    </div>
                  )}

                  <div>
                    <span className="tandc">
                      By continuing, I agree to the Terms of Use & Privacy
                      Policy
                    </span>
                    <span className="gethelp">
                      Having trouble logging in? <span>Get help</span>{" "}
                    </span>
                  </div>
                </div>
              </Box>
            </Col>
          </Row>
        )}

        {isRegistration && <CreateNewUser newEmail={newEmail} />}
      </div>
    </section>
  );
}

export default Login;
